<template>
  <Modal
    :show="show.restoreRevisionConfirm"
    action-text="Restore"
    @close="close"
    @action="confirm"
  >
    <template #title>
      Restore this revision
    </template>

    <template #content>
      This will replace the current job profile content with the content from this revision.
      Are you sure you want to continue?
    </template>
  </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useAppRoute } from '@/stores/app/route';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import Modal from '@/components/shared/Modal.vue';

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const close = () => setModal({ field: 'restoreRevisionConfirm', value: false });

const { route } = storeToRefs(useAppRoute());
const router = useRouter();
const confirm = async () => {
  close();
  await useCurrentJobProfile().restoreRevision();
  router.push({ query: { ...(route.value?.query || {}), sideRevision: undefined } });
};
</script>
